import { useTranslation } from "react-i18next";

// لافتة صغيرة أعلى الكاميرا عندما يكون اليوم عطلة والدوام مسموحاً للموظف.
export const OffDayAllowedBanner = () => {
  const { t } = useTranslation();
  return (
    <p
      className="mt-2 rounded-xl bg-primary/10 px-3 py-2 text-center text-[13px] font-bold text-primary"
      data-testid="off-day-allowed-banner"
    >
      {t("offDay.allowed")}
    </p>
  );
};
